import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody } from 'reactstrap';

type LogoutNotificationProps = {
  logout: () => void;
  cancel: () => void;
};

const LogoutNotification = ({ logout, cancel }: LogoutNotificationProps) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardBody className="text-center">
        <h1>{t('auth.logoutPrompt')}</h1>
        <div className="mt-4 d-flex flex-column gap-2 align-items-center">
          <Button color="primary" onClick={logout} size="full">
            {t('auth.logoutButton')}
          </Button>
          <Button onClick={cancel} size="full">
            {t('global.cancel')}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default LogoutNotification;
